import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PastClass from '../../../../pages/common/Statistic/PastClasses/PastClass'
import UsePagination from '../../../pagination'
import DropDown from '../../../Input/DropDown'

import { getStudentPastClasses } from '../../../../routing/fetchingfunction/dashboard/dashboard.action'
import {
  selectLoadingStudentPastClasses,
  selectStudentPastClassesPagination,
} from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { getPaginationTotalLength } from '../../../../helpers'

const StudentPastClasses = () => {
  const dispatch = useDispatch()

  const {
    studentPastClasses,
    studentPastClassesPage,
    studentPastClassesPageSize,
    studentPastClassesTotal,
  } = useSelector(selectStudentPastClassesPagination)
  const isLoading = useSelector(selectLoadingStudentPastClasses)

  const handlePageChange = (_, value) => {
    if (value !== studentPastClassesPage) {
      dispatch(
        getStudentPastClasses({
          page: value,
        })
      )
    }
  }

  useEffect(() => {
    dispatch(getStudentPastClasses())
  }, [dispatch])

  const pastClassesContent = studentPastClasses.map((studentPastClass) => {
    return <PastClass key={studentPastClass.id} pastClass={studentPastClass} />
  })

  return (
    <div className="mt-[64px] mb-[20px]">
      <div className="flex items-center justify-between mb-[20px]">
        <h3 className="text-2xl font-bold text-white">Past Classes</h3>

        {/*<div className="flex items-center gap-x-[20px]">*/}
        {/*  <DropDown*/}
        {/*    menuItems={[*/}
        {/*      {*/}
        {/*        value: 'date',*/}
        {/*        label: 'Date',*/}
        {/*      },*/}
        {/*    ]}*/}
        {/*    value="date"*/}
        {/*    placeholder="Date"*/}
        {/*    className="!h-[44px]"*/}
        {/*  />*/}
        {/*</div>*/}
      </div>

      {pastClassesContent}

      {studentPastClassesTotal > studentPastClassesPageSize && (
        <div className="w-full flex items-center justify-center">
          <UsePagination
            count={getPaginationTotalLength(studentPastClassesTotal, studentPastClassesPageSize)}
            page={studentPastClassesPage}
            onChange={handlePageChange}
            loading={isLoading}
          />
        </div>
      )}
    </div>
  )
}

export default StudentPastClasses
